export const onKeyDown = (
  event: React.KeyboardEvent<HTMLElement>,
  isMenuOpen: boolean = false
) => {
  if (event.key === "Enter" && !isMenuOpen) {
    event.preventDefault();
  }
};
